var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.49943 8.9294L11.1193 13.8749C11.1843 13.9321 11.2631 13.9714 11.3479 13.989C11.4327 14.0067 11.5206 14.0019 11.603 13.9754C11.6855 13.9488 11.7596 13.9012 11.8181 13.8374C11.8766 13.7736 11.9176 13.6956 11.9369 13.6112L14.2878 3.3529C14.3081 3.2642 14.3039 3.17165 14.2755 3.0852C14.2471 2.99875 14.1956 2.92169 14.1267 2.86231C14.0577 2.80294 13.9739 2.76351 13.8842 2.74827C13.7945 2.73303 13.7023 2.74256 13.6176 2.77584L2.0828 7.30736C1.98227 7.34686 1.89723 7.41784 1.84041 7.5097C1.78359 7.60155 1.75804 7.70933 1.76758 7.81692C1.77712 7.9245 1.82125 8.02611 1.89335 8.10652C1.96545 8.18694 2.06166 8.24185 2.16757 8.26303L5.49943 8.9294Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 8.9296L14.007 2.78564",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.30669 11.3993L6.35355 13.3525C6.28363 13.4224 6.19454 13.47 6.09755 13.4893C6.00056 13.5086 5.90002 13.4987 5.80866 13.4609C5.7173 13.423 5.63921 13.3589 5.58427 13.2767C5.52933 13.1945 5.5 13.0978 5.5 12.9989V8.92944",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/Send.328572f1056d76ad427a52df2a7c9ba5.svg";
export { ForwardRef as ReactComponent };